import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const feedbackOnFeedbackV2FeatureFlag: FeatureFlagType = {
  name: 'feedback_on_feedback_v2',
  fallback: false,
};

export const useIsFeedbackOnFeedbackV2Enabled = () => {
  const [status, isFeedbackOnFeedbackV2Enabled] = useFeatureFlag(
    feedbackOnFeedbackV2FeatureFlag,
  );

  return { status, isFeedbackOnFeedbackV2Enabled };
};
